import axiosClient from "api/apiClient";

export const APIGetAddresses = () => {
  return axiosClient.get(`/addresses`);
};
